import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/reimpressao-protocolo`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        search(queryParms = {}) {
            return repository.get(`${baseUrl}/search?${urlUtil.serialize(queryParms)}`)
        },
    }
}